export const variants = [
  {
    props: { variant: "Secondary" },
    style: ({ theme }) => ({
      textTransform: "none",
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 400,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      minHeight: 1,
      minWidth: 1,
      "&.Mui-selected": {
        color: theme.palette.text.secondary_tab,
        fontWeight: 450,
      },
      "&:hover": {
        color: theme.palette.text.secondary_tab,
      },
    }),
  },
  {
    props: { variant: "Secondary Disabled" },
    style: ({ theme }) => ({
      width: 1,
      minWidth: 1,

      paddingLeft: 0,
      paddingRight: 0,

      paddingTop: 0,
      paddingBottom: 0,

      paddingInlineStart: theme.spacing(0.75),
      paddingInlineEnd: theme.spacing(0.75),

      minHeight: 1,
    }),
  },
];
